var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/image-rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 13.8L18.3549 11.8955C16.9804 10.9059 15.102 11.0082 13.8431 12.1412L10.1569 15.4588C8.89798 16.5918 7.01958 16.6941 5.64511 15.7045L3 13.8M6.6 21H17.4C19.3882 21 21 19.3882 21 17.4V6.6C21 4.61177 19.3882 3 17.4 3H6.6C4.61177 3 3 4.61177 3 6.6V17.4C3 19.3882 4.61177 21 6.6 21ZM11.1 8.85C11.1 10.0926 10.0926 11.1 8.85 11.1C7.60736 11.1 6.6 10.0926 6.6 8.85C6.6 7.60736 7.60736 6.6 8.85 6.6C10.0926 6.6 11.1 7.60736 11.1 8.85Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRectangle);
export default __webpack_public_path__ + "static/media/image-rectangle.e38397585bac0fb99c56c20c3c6b7a19.svg";
export { ForwardRef as ReactComponent };